import classNames from 'classnames/bind';
import { string } from 'prop-types';
import React, { useCallback, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { actionTypes } from '../../store/actions/menuModal';
import { getIsMenuModalSearchActive, getMenuModalSearchQuery, getMenuModalShow } from '../../store/selectors';

import { BasketIcon } from '../Icons';
import Modal from '../Modal';
import SearchInput from '../SearchInput';

import s from './index.module.css';

const cx = classNames.bind(s);

const MenuModal = ({ dopContent }) => {
  const isShow = useSelector(getMenuModalShow);
  const isSearchActive = useSelector(getIsMenuModalSearchActive);
  const searchQuery = useSelector(getMenuModalSearchQuery);
  const dispatch = useDispatch();
  let searchWrapperRef = useRef(null);

  // Causes memory leak on fast multiple rerenders
  // const handleClickOutsideSearch = () => {
  //   dispatch({ type: actionTypes.TOGGLE_SEARCH, payload: false });
  //   dispatch({ type: actionTypes.CHANGE_SEARCH_QUERY, payload: '' })
  // };

  // useClickOutside(searchWrapperRef, (e) => {
  //   handleClickOutsideSearch(e);
  // });

  const close = useCallback(() => dispatch({ type: actionTypes.CLOSE }), [dispatch]);

  const handleResize = useCallback(() => {
    if (isShow && window.innerWidth >= 740) {
      close();
    }
  }, [isShow, close]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  if (!isShow) {
    return null;
  }

  return (
    <Modal className={s.modal} wrapperClassName={s.modalWrapper} onClose={close} withOverlay={false} showClose>
      <div className={s.modalBody}>
        {dopContent}
        <div className={s.search} ref={searchWrapperRef}>
          <SearchInput searchQuery={searchQuery} isSearchActive={isSearchActive} />
        </div>
        <a className={cx(s.navigation, s.withIcon)} href="/cart">
          <BasketIcon />
          <span className={s.basketText}>Корзина</span>
        </a>

        <ul className={s.navigationMenu}>
          <li className={s.listItem}>
            <a className={s.navigation} href="/payment">
              Оплата
            </a>
          </li>
          <li className={s.listItem}>
            <a className={s.navigation} href="/delivery">
              Доставка
            </a>
          </li>
          <li className={s.listItem}>
            <a className={s.navigation} href="/returns">
              Возврат
            </a>
          </li>
        </ul>
      </div>
    </Modal>
  );
};

MenuModal.propTypes = {
  className: string,
};

MenuModal.defaultProps = {
  className: null,
};

export default MenuModal;
